var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.043,
    height: 32.043,
    viewBox: "0 0 32.043 32.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "models",
    transform: "translate(-133.641 -663.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M153.048,709.258l-5.92.828a11.234,11.234,0,0,0,4.107,6.835l3.588-4.754A5.368,5.368,0,0,1,153.048,709.258Z",
    transform: "translate(-8.34 -28.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M153.442,692.754l-4.757-3.59a11.228,11.228,0,0,0-1.971,7.789l5.921-.829A5.366,5.366,0,0,1,153.442,692.754Z",
    transform: "translate(-8.036 -15.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M180.934,678.729a11.226,11.226,0,0,0-7.741-2.071l.817,5.839a5.356,5.356,0,0,1,3.4.9Z",
    transform: "translate(-24.458 -7.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M187.459,691.034l5.762-.806a11.221,11.221,0,0,0-3.961-6.889L185.742,688A5.364,5.364,0,0,1,187.459,691.034Z",
    transform: "translate(-32.219 -12.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M159.412,722.752a11.227,11.227,0,0,0,7.669,1.925l-.817-5.846A5.353,5.353,0,0,1,163,718Z",
    transform: "translate(-15.936 -33.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M188.062,707.364l4.66,3.517a11.228,11.228,0,0,0,2.024-7.622l-5.763.8A5.353,5.353,0,0,1,188.062,707.364Z",
    transform: "translate(-33.653 -24.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M179.229,717.19l.816,5.836a11.233,11.233,0,0,0,6.779-4l-4.664-3.52A5.359,5.359,0,0,1,179.229,717.19Z",
    transform: "translate(-28.191 -31.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M147.285,679.7a.4.4,0,0,0,.141.4l9.185,7.163a.386.386,0,0,0,.424.038.394.394,0,0,0,.209-.375l-1.2-8.215a.4.4,0,0,0-.152-.285.407.407,0,0,0-.313-.075l-7.984,1.055A.394.394,0,0,0,147.285,679.7Z",
    transform: "translate(-8.431 -8.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M144.722,664.2l-.221,4.238a12.459,12.459,0,0,1,3.92-1.058l-2.3-3.549C145.645,663.938,145.178,664.059,144.722,664.2Zm17.412,14.41,3.551-2.3c-.1-.473-.226-.939-.371-1.4l-4.238-.221A12.413,12.413,0,0,1,162.133,678.612Zm-2.3-6.059,1.928-3.779q-.489-.534-1.022-1.023l-3.779,1.928A12.6,12.6,0,0,1,159.837,672.553Zm-21.588,2.14-4.238.221c-.145.456-.266.922-.371,1.4l3.551,2.3A12.425,12.425,0,0,1,138.25,674.693Zm14.958-10.86-2.3,3.549a12.46,12.46,0,0,1,3.919,1.058l-.22-4.238C154.147,664.059,153.68,663.938,153.207,663.833Zm3.756,26.2,3.779,1.928q.534-.488,1.022-1.023l-1.928-3.779A12.574,12.574,0,0,1,156.964,690.028Zm-3.756,5.848c.472-.1.939-.226,1.4-.37l.22-4.238a12.454,12.454,0,0,1-3.919,1.058ZM137.192,681.1l-3.551,2.3c.1.473.226.94.371,1.4l4.238.221A12.431,12.431,0,0,1,137.192,681.1Zm23.884,3.92,4.238-.221c.145-.456.266-.923.371-1.4l-3.551-2.3A12.419,12.419,0,0,1,161.076,685.016Zm-21.588,2.139-1.928,3.779q.488.534,1.022,1.023l3.779-1.928A12.574,12.574,0,0,1,139.488,687.155Zm5.234,8.351c.456.145.923.266,1.4.37l2.3-3.55a12.453,12.453,0,0,1-3.92-1.058Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelsIcon);
export default __webpack_public_path__ + "static/media/modelsIcon.dd6a72300bcbe456481b50229073dcb1.svg";
export { ForwardRef as ReactComponent };